export default "__VITE_ASSET__BVmGEy2i__"